import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 1em 0 1.5em 0;

	.title {
		font-size: 1em;
		font-weight: 600;
	}
`;
